import { Invoice } from '~/types/invoice'

export const convertInvoice = (data: any): Invoice | null => {
  if (!data) return null

  const result: Invoice = {
    invoiceNumber: data.InvoiceNumber,
    storeId: data.StoreId,
    customerId: data.CustomerId,
    date: data.Date,
    id: data.Id,
    totalAmount: data.TotalAmount,
  }

  return result
}

export const convertInvoices = (data: any): Invoice[] => {
  return data.map((item) => convertInvoice(item))
}
